module.exports = "<tb-data-group></tb-data-group>\n";